import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formHelpers from './utils/form';
import SectionEditActions from './SectionEditActions';
export default {
  name: 'MallDecorationTab',
  components: {
    SectionEditActions: SectionEditActions
  },
  mixins: [formHelpers],
  props: {
    formData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'add'
    },
    editSaving: {
      type: Boolean,
      default: false
    },
    decorationPersonList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isTaskFormDisabled: {
      type: Function,
      required: true
    },
    isEditingTask: {
      type: Function,
      required: true
    },
    isViewTaskDisabled: {
      type: Function,
      required: true
    },
    showProjectInfoEditButton: {
      type: Function,
      required: true
    },
    startProjectInfoEdit: {
      type: Function,
      required: true
    },
    confirmProjectInfoEdit: {
      type: Function,
      required: true
    },
    cancelProjectInfoEdit: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleBudgetInput: function handleBudgetInput(value) {
      var raw = String(value || '');
      var cleaned = raw.replace(/[^\d.]/g, '');
      var dotIndex = cleaned.indexOf('.');
      var integerPart = '';
      var decimalPart = '';
      if (dotIndex === -1) {
        integerPart = cleaned;
      } else {
        integerPart = cleaned.slice(0, dotIndex);
        decimalPart = cleaned.slice(dotIndex + 1).replace(/\./g, '');
      }
      integerPart = integerPart.slice(0, 9);
      decimalPart = decimalPart.slice(0, 2);
      var nextValue = integerPart;
      if (dotIndex !== -1) {
        nextValue = "".concat(integerPart, ".").concat(decimalPart);
      }
      this.formData.items.mall_decoration.budget = nextValue;
    }
  }
};